
    export interface IInvalidSolicitorNumberScope extends ng.IScope {
        invalidSolicitorNumberCtrl: InvalidSolicitorNumberController;
    }

    export class InvalidSolicitorNumberController {
        public static $inject = ['$scope', '$modalInstance'];
        constructor(
            public $scope: IInvalidSolicitorNumberScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance) {

            $scope.invalidSolicitorNumberCtrl = this;

        }

        public closeModal = () => {
            this.$modalInstance.close();
        }

    }
